var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4443 4.875C16.4443 5.17337 14.4053 5.78902 14.1943 6C13.9834 6.21098 13.3677 8.25 13.0693 8.25C12.771 8.25 12.1553 6.21098 11.9443 6C11.7334 5.78902 9.69434 5.17337 9.69434 4.875C9.69434 4.57663 11.7334 3.96098 11.9443 3.75C12.1553 3.53902 12.771 1.5 13.0693 1.5C13.3677 1.5 13.9834 3.53902 14.1943 3.75C14.4053 3.96098 16.4443 4.57663 16.4443 4.875Z",
    fill: "#236BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5C8.03043 4.5 9.12493 8.12493 9.5 8.5C9.87507 8.87507 13.5 9.96957 13.5 10.5C13.5 11.0304 9.87507 12.1249 9.5 12.5C9.12493 12.8751 8.03043 16.5 7.5 16.5C6.96957 16.5 5.87507 12.8751 5.5 12.5C5.12493 12.1249 1.5 11.0304 1.5 10.5C1.5 9.96957 5.12493 8.87507 5.5 8.5C5.87507 8.12493 6.96957 4.5 7.5 4.5Z",
    fill: "#236BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUAi);
export default __webpack_public_path__ + "static/media/u_AI.7ba9e3e1.svg";
export { ForwardRef as ReactComponent };